<template>
  <!-- <nav>
    <router-link to="/">Home</router-link>
  </nav> -->
  <div class="menu">
    <div class="xzy_logo_text" @click="goPage('/')">
      <img style="width: 100px" src="@/assets/images/xzy_logo_text.png" />
    </div>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :ellipsis="false" @select="handleSelect" active-text-color="#ff8f00">
      <template v-if="now_route_path != '/service'">
        <el-menu-item index="/">首页</el-menu-item>
        <el-menu-item index="/about">关于我们</el-menu-item>
        <el-menu-item index="/customer">服务客户</el-menu-item>
      </template>
      <template v-else-if="now_route_path == '/service'">
        <el-menu-item index="/">返回官网</el-menu-item>

      </template>

    </el-menu>
  </div>
  <div style="margin-top: 60px;">
    <router-view />
    <div class="introduce">
      <div class="introduce_item">
        <div class="pettyb_small_title">天津汇垚科技有限公司</div>
        <div><i class="iconfont icon-address" style="margin-right: 10px;"></i>联系地址：天津市津南区鑫谷科创产业园(永胜道东200米)1号楼407</div>
        <div><i class="iconfont icon-dianhua" style="margin-right: 10px;"></i>联系座机：022-88195081</div>
        <div><i class="iconfont icon-shouji" style="margin-right: 10px;"></i>联系电话：18622470093/15803434022</div>
        <div><i class="iconfont icon-hulianwang" style="margin-right: 10px;"></i>电子邮箱：i@mbcore.com</div>
        <div class="code_box">
          <div>
            <img src="@/assets/images/yq_mini.jpg" alt="" class="code_img">
            <div>扫一扫查看小程序</div>
          </div>
          <div>
            <img src="@/assets/images/xzy_gzh.jpg" alt="" class="code_img">
            <div>关注小砖猿公众号</div>
          </div>
          <div>
            <img src="@/assets/images/kf.jpg" alt="" class="code_img">
            <div>扫一扫添加客服微信</div>
          </div>
        </div>
      </div>
      <div class="introduce_item">
        <div class="pettyb_small_title">小砖猿</div>
        <div @click="goPage('/')" style="cursor: pointer;">首页</div>
        <div @click="goPage('/about')" style="cursor: pointer;">关于我们</div>
        <div @click="goPage('/customer')" style="cursor: pointer;">服务客户</div>
      </div>
      <div class="introduce_item">
        <div class="pettyb_small_title">小砖猿 | 知活动</div>
        <div @click="goProduct('https://zhd.mbcore.com/')" style="cursor: pointer;">首页</div>
        <div @click="goProduct('https://zhd.mbcore.com/#/quotation')" style="cursor: pointer;">报价明细</div>
      </div>
      <div class="introduce_item">
        <div class="pettyb_small_title">小砖猿 | 平安校园</div>
        <div @click="goProduct('https://hxd.mbcore.com/')" style="cursor: pointer;">首页</div>
      </div>
    </div>
    <div class="copyright">Copyright © 2015~2025 天津汇垚科技有限公司 版权所有 <span class="beian" @click="goProduct('https://beian.miit.gov.cn')">津ICP备17007759号</span></div>
  </div>


</template>
<script setup>
import { ref, reactive, onMounted,onUnmounted, getCurrentInstance, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
const now_route_path = ref('/')
const activeIndex = ref('/')
const handleSelect = (key, keyPath) => {
  console.log(key, keyPath)
  router.push({ path: key })
  window.scrollTo(0, 0)
}
const deviceScreen=ref(3)//1小屏幕设备 2中等屏幕设备 3大屏幕设备
const isMobile = ref(2) // 是否是移动端 1是 2否
watch(
  () => route.path, // 监听 route.path 的变化
  (newPath) => {
    activeIndex.value = newPath
    now_route_path.value = newPath
  }
);
onMounted(() => {

  if (checkMobile()) {
    console.log('This is a mobile device');
    isMobile.value = 1
  } else {
    console.log('This is a desktop device');
    isMobile.value = 2
  }
  localStorage.setItem("xzy_isMobile", isMobile.value);
  window.addEventListener('resize', updateScreenWidth);
  updateScreenWidth()
})
onUnmounted(() => {
  // 组件销毁时移除监听器
  window.removeEventListener('resize', updateScreenWidth);
})
const loading = ref(false)
function updateScreenWidth() {
  const width = window.innerWidth; // 获取当前窗口宽度
  // 根据宽度执行逻辑
  if (width < 600) {
    deviceScreen.value=1
    console.log('小屏幕设备');
  } else if (width >= 600 && width < 1024) {
    console.log('中等屏幕设备');
    deviceScreen.value=2
  } else {
    console.log('大屏幕设备');
    deviceScreen.value=3
  }
}
const goPage = (path, index) => {
  activeIndex.value = path
  router.push({ path })
  window.scrollTo(0, 0)
}
const checkMobile = () => {
  const userAgent = navigator.userAgent;
  return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
const goProduct = (url) => {
  if (url) {
    window.open(url, '_blank')
  }
}
</script>

<style scoped>
/* 手机 */
@media screen and (max-width: 600px) {
  .menu {
    padding: 0;
  }

  .introduce {
    padding: 0 20px;
  
  }

  .copyright {
    padding: 0 20px;
  }
}

/* 平板 */
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .menu {
    padding: 0 ;
  }

  .introduce {
    /* padding: 0 20px; */
    width: 80%;
  }
  .copyright {
    padding: 0 20px;
  }
}

/* 桌面 */
@media screen and (min-width: 1025px) {
  .menu {
    padding: 0 100px;
  }

  .introduce {
    /* padding: 0 20px; */
    width: 80%;
  }
}

.menu {
  position: fixed;
  top: 0;
  background-color: #fff;
  /* width: 100%; */
  left: 0;
  right: 0;
  z-index: 9999;

  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}

.el-menu--horizontal.el-menu {
  border-bottom: none
}

.el-menu--horizontal>.el-menu-item {
  margin-right: 0;
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus {
  background-color: #ff8f0010;
  color: #ff8f00
}

.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover {
  background-color: #ff8f0010;
  color: #ff8f00
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}



.xzy_logo_text {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.code_img {
  width: 80px;
  height: 80px;
  cursor: pointer;
}

.introduce {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  margin: 40px auto;
  background-color: #fff;
}

.introduce_item {
  font-size: 13px;
  color: #a7a7a7;
  line-height: 2.3;
}

.introduce_title {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}

.copyright {
  font-size: 13px;
  color: #a7a7a7;
  text-align: center;
  margin-bottom: 40px;

}

.beian {
  cursor: pointer;
}

.beian:hover {
  color: #409eff
}

.code_box {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;

}

.code_box div {
  text-align: center;
}
</style>
